import RoundedButton from 'components/RoundedButton';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getCta } from 'utils/common';

interface IProps {
  overrideLabel?: string;
  overrideUrl?: string;
  id?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const StandardCTA = observer(
  ({ overrideLabel, overrideUrl, id, onClick, style = {} }: IProps) => {
    const { subscriptionStatusInfo } = useUserStore();

    const cta = getCta(subscriptionStatusInfo);

    if (!cta) {
      return null;
    }

    return (
      <RoundedButton
        href={overrideUrl || (!onClick ? cta.url : undefined)}
        id={id}
        className="standardCTA"
        onClick={onClick}
        style={{ ...style }}
      >
        {overrideLabel || cta.label}
      </RoundedButton>
    );
  }
);

export default StandardCTA;
